import 'cropperjs/dist/cropper.css';

import { Button } from 'components/Button';
import { convertBase64ToFile } from 'helpers/utils';
import React, { useEffect, useMemo, useState } from 'react';
import Cropper from 'react-cropper';
import Dropzone from 'react-dropzone';
import { useFormContext, useWatch } from 'react-hook-form';
import { IPartnerCreate } from 'types/Partner';

import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Typography,
} from '@mui/material';
import { Box, useTheme } from '@mui/system';
import { PartnerService } from 'services';

const CropImageOprions = {
  width: 500,
  height: 500,
  minWidth: 500,
  minHeight: 500,
  maxWidth: 500,
  maxHeight: 500,
  fillColor: '#FFF',
  imageSmoothingEnabled: false,
  imageSmoothingQuality: 'medium',
};

export const PartnerImageForm: React.FC = () => {
  const { palette } = useTheme();
  const [cropper, setCropper] = useState<any>();
  const { setValue, getValues, control } = useFormContext<IPartnerCreate>();
  const [open, setOpen] = useState(false);
  const [selectedImage, setSelectedImage] = useState('');

  const partnerId = getValues()._id;
  // @ts-ignore
  const [imageFile, image] = useWatch({
    control,
    name: ['imageFile', 'image'],
  });

  const handleConfirm = async () => {
    if (typeof cropper === 'undefined') {
      return;
    }

    setOpen(false);
    try {
      const base64Image = cropper
        .getCroppedCanvas(CropImageOprions)
        .toDataURL();

      const croppedImage = await convertBase64ToFile(
        base64Image,
        'partnerImage.png',
        'image/png'
      );

      setValue('imageFile', croppedImage);
    } catch (reason) {}
  };

  useEffect(() => {
    setSelectedImage('');
  }, [imageFile]);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleDropFile = (acceptedFiles: File[]) => {
    const file = acceptedFiles[0];

    if (!file) {
      return;
    }

    try {
      const reader = new FileReader();
      reader.onload = () => {
        setSelectedImage(reader.result as any);
      };
      reader.readAsDataURL(acceptedFiles[0]);

      handleOpen();
    } catch (reason) {
      alert('Não foi possível carregar a imagem.');
    }
  };

  const preview = useMemo(() => {
    if (imageFile) {
      return URL.createObjectURL(imageFile);
    }

    return null;
  }, [imageFile]);

  useEffect(() => {
    return () => {
      if (preview) {
        URL.revokeObjectURL(preview);
      }
    };
  }, [preview]);

  return (
    <>
      <Box sx={{ cursor: 'pointer' }}>
        <Dropzone
          onDrop={handleDropFile}
          multiple={false}
          accept={{
            'image/jpeg': [],
            'image/png': [],
          }}
        >
          {({ getRootProps, getInputProps }) => (
            <section>
              <div
                {...getRootProps()}
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                }}
              >
                <input {...getInputProps()} />

                <Box
                  height={94}
                  width={94}
                  borderRadius="100%"
                  border="solid"
                  borderColor={palette.primary.main}
                  overflow="hidden"
                >
                  {Boolean(preview) ? (
                    <img
                      width={90}
                      height={90}
                      src={preview as string}
                      alt=""
                    />
                  ) : (
                    <>
                      {Boolean(image) && (
                        <img
                          width={90}
                          height={90}
                          src={PartnerService.getPartnerImage(partnerId)}
                          alt=""
                        />
                      )}
                    </>
                  )}
                </Box>

                <Typography marginTop={1}>Adicionar marca</Typography>
              </div>
            </section>
          )}
        </Dropzone>
      </Box>

      <Dialog open={open} onClose={handleOpen}>
        <DialogTitle>Adicionar marca</DialogTitle>
        <DialogContent>
          <DialogContentText fontSize={14}>
            Ajuste o tamanho e posição da imagem
          </DialogContentText>

          <Cropper
            style={{ height: 400, width: '100%' }}
            zoomTo={0}
            initialAspectRatio={1}
            preview=".img-preview"
            src={selectedImage}
            viewMode={1}
            minCropBoxHeight={10}
            minCropBoxWidth={10}
            background={false}
            responsive={true}
            autoCropArea={1}
            checkOrientation={false} // https://github.com/fengyuanchen/cropperjs/issues/671
            onInitialized={(instance) => {
              setCropper(instance);
            }}
            guides={true}
            aspectRatio={1}
            height={500}
            width={500}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Cancelar</Button>
          <Button onClick={handleConfirm}>Confirmar</Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default PartnerImageForm;

